import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { doc } from "firebase/firestore";
import { useFirestore, useFirestoreDocData } from "reactfire";
import { useLeague } from "context/leagueContext";
import { useUser } from "reactfire";

function useLeagueData() {
  const { tournamentId } = useParams();
  const { status, data: user } = useUser();
  const { dispatch } = useLeague();
  const firestore = useFirestore();
  const userLeagueDataRef = doc(
    firestore,
    "userTournaments/" + tournamentId + "/users",
    user?.uid
  );
  const { status: userLeagueDataStatus, data: userLeagueData } =
    useFirestoreDocData(userLeagueDataRef);

  const leagueInfoCollection = doc(firestore, "userTournaments", tournamentId);
  const { status: leagueInfoStatus, data: leagueInfoData } =
    useFirestoreDocData(leagueInfoCollection, {
      idField: "id",
    });

  useEffect(() => {
    if (leagueInfoStatus === "success" && userLeagueDataStatus === "success") {
      dispatch({
        type: "setLeagueData",
        value: {
          leagueInfo: leagueInfoData,
          userLeagueData: userLeagueData,
        },
      });
    }
  }, [leagueInfoStatus, userLeagueDataStatus, leagueInfoData, userLeagueData]);

  return;
}

export { useLeagueData };
